/**
 * This method is similar to the `localTracks` method, however this method returns
 *  all of the sender's tracks (ended or not) rather than just the active/live ones.
 *
 * @method senderTracks
 * @return {Array} List of Track objects added to the Peer locally.
 */
export default function senderTracks () {
  const { proxyPeer, log } = this
  log.info('Getting sender tracks.')

  // Return the list of Tracks from senders.
  return (
    proxyPeer
      .getSenders()
      /**
       * Remove any Senders that do not have an associated track.
       * We only want to retrieve Senders that do have tracks, because those are
       *    the local tracks that have been added to the Peer.
       * Senders without tracks are part of a Transceiver where the Receiver has
       *    a remote track, but no local track has been added to it. We don't
       *    care about this for the "get local tracks" operation.
       */
      .filter(sender => Boolean(sender.track))
      .map(sender => sender.track)
  )
}
